import type { FC, PropsWithChildren } from 'react';
import { Theme, styled, useMediaQuery } from '@mui/material';
import { Banner } from 'src/components/banner';
import { Toaster } from 'src/components/toaster';
import { useBanner } from 'src/hooks/components/use-banner';
import { useMobileNavigation } from 'src/hooks/components/use-mobile-navigation';
import { MOBILE_BREAKPOINT, SIDE_NAV_WIDTH, useSections } from './config';
import { Header } from './header';
import { Navigation } from './navigation';

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',

  // fixed dimensions for parent
  width: '100vw',
  maxWidth: '100%'
});

const Body = styled('div', {
  shouldForwardProp: (prop: string) => !['mobile'].includes(prop)
})<{ mobile: boolean }>(({ mobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',

  // align to navigation drawer
  ...(!mobile && {
    paddingLeft: `${SIDE_NAV_WIDTH}px`
  })
}));

/**
 * Default layout after login
 */
export const Layout: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  const sections = useSections();
  const navigation = useMobileNavigation();
  const banner = useBanner();

  const mobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(MOBILE_BREAKPOINT)
  );

  return (
    <Root>
      {banner && <Banner text={banner} />}
      <Header
        mobile={mobile}
        onNavigationOpen={navigation.handleOpen}
      />
      <Navigation
        mobile={mobile}
        banner={!!banner}
        sections={sections}
        open={navigation.open}
        onClose={navigation.handleClose}
      />
      <Body mobile={mobile}>{children}</Body>
      <Toaster />
    </Root>
  );
};
